module.exports = __webpack_public_path__ + "static/steps-path-4-c842cc6e48ab5984e936e9908bdfb370.jpg";